import * as Yup from 'yup';
import { Payments } from '@prisma/client';
import { useMutation } from '@tanstack/react-query';
import { voidPayment } from '../../services/payments';

function useVoidPayment({
  onError,
  onSuccess,
}: {
  onSuccess?: (payment: Payments) => void | Promise<void>;
  onError?: (error: string) => void | Promise<void>;
}) {
  return useMutation({
    mutationFn: async (paymentId: string) => {
      await Yup.string().min(1).required().validate(paymentId);

      const response = await voidPayment({ paymentId });

      return response;
    },
    onSuccess,
    onError: err => {
      onError?.(err?.message);
    },
  });
}

export default useVoidPayment;
